import { Box } from "@chakra-ui/react";
import Image from "next/image";

import { IImage } from "../../../../../utils/types";

import styles from "./GuideContentBody.module.scss";

const skeletonBlurDataURL =
  "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAFklEQVR42mN8//HLfwYiAOOoQvoqBABbWyZJf74GZgAAAABJRU5ErkJggg==";

interface ImageContentProps {
  field: IImage;
}

export default function ImageContent({ field }: ImageContentProps) {
  // svg인 경우 Safari에서 Blurry Issue가 발생하여 img 태그 대신 object 태그를 사용한다.
  if (field.src?.endsWith(".svg")) {
    return (
      <Box
        {...field?.styles?.container}
        className={styles.imageContainer}
        data-testid="image-content-svg"
      >
        <object
          data={field.src}
          type="image/svg+xml"
          style={{ width: "100%", height: "auto" }}
          aria-label={field.alt}
        >
          {field.alt}
        </object>
      </Box>
    );
  }

  const cn = field?.className
    ? styles[field.className as keyof typeof styles]
    : styles.imageContainer;

  return (
    <Box
      {...field?.styles?.container}
      className={cn}
      data-testid="image-content"
    >
      <Image
        priority
        src={field.src}
        alt={field.alt}
        width={320}
        height={320}
        sizes="100vw"
        style={{ width: "100%", height: "auto" }}
        placeholder="blur"
        blurDataURL={skeletonBlurDataURL}
      />
    </Box>
  );
}
